export class PieChartConfig {
    title: string;
    pieHole: number
    legend: string;

    constructor(title: string, pieHole: number, legend: string) {
        this.title = title;
        this.pieHole = pieHole;
        this.legend = legend;
    }
}